import { Injectable } from '@angular/core';
import { FormActionHandlerService } from './base.service';
import { FormShareService } from '../share.service';
import { FormStatusService } from '../status.service';
import { FormDataService } from '../data.service';
import { FormEmailService } from '../email.service';
import { SwalService } from '../../../fastlane-common/services/swal.service';
import { User } from '../../../user/models/user.model';
import { formStatus } from '../../form.constants';

@Injectable()
export class SubmitExaminationActionHandlerService extends FormActionHandlerService {
  constructor(
    private shareService: FormShareService,
    private statusService: FormStatusService,
    private dataService: FormDataService,
    private emailService: FormEmailService,
    private swal: SwalService
  ) {
    super();
  }

  exec(): Promise<any> {
    const that = this;
    return new Promise((resolve, reject) => {
      that.swal
        .yesOrNo({
          title: 'Submit the examination documents to LED?',
          text:
            'Make sure every required examination document has been attached before submitting.'
        })
        .then(() => {
          that.swal.load('Submitting Examination...', 'Please wait.');

          that.statusService.changeStatus(formStatus.examinationSubmitted);
          that.shareService.form.modifiedDate = new Date();

          that.dataService.saveForm().subscribe(
            () => that.notifyAndFinish(resolve),
            errorSaving => {
              if (errorSaving === 409) {
                reject(errorSaving);
              } else {
                reject(
                  'We were unable to submit your examination. Please try again later.'
                );
              }
            }
          );
        })
        .catch(() => resolve());
    });
  }

  private notifyAndFinish(resolve: () => void): void {
    const that = this;
    that.swal.load('Notifying LED...', 'Please wait.');

    that.shareService.getProgramManager().subscribe(
      manager => {
        const ccList: User[] = manager ? [manager] : [];
        that.sendSubmissionEmail(ccList, resolve);
      },
      () => that.sendSubmissionEmail([], resolve)
    );
  }

  private sendSubmissionEmail(ccList: User[], resolve: () => void): void {
    const that = this;
    that.emailService.sendSubmissionSuccessfulEmail(ccList).subscribe(
      () => {
        that.swal
          .success({
            title: 'Examination submitted.',
            text:
              'Your examination documents have been submitted to LED for review.'
          })
          .then(() => resolve())
          .catch(() => resolve());
      },
      () => {
        that.swal
          .error({
            title: 'Examination submitted, but the notification email could not be sent.',
            text:
              'Your examination is now Examination Submitted. Please contact LED to confirm receipt.'
          })
          .then(() => resolve())
          .catch(() => resolve());
      }
    );
  }
}
